import React from 'react';
import { SvgIcon } from '@mui/material';

const AirTransportIcon = (props) => {
    return (
        <SvgIcon
            width="135"
            height="110"
            viewBox="0 0 135 110"
            fill="none"
            {...props}>
            <path
                d="M14.0625 87.0834H120.938V96.25H14.0625V87.0834ZM124.144 44.1604C122.934 40.4938 118.322 38.3167 113.822 39.3021L83.925 45.8334L45.1125 16.3396L34.2563 18.7229L57.5438 51.6084L29.5875 57.7042L18.5344 50.6229L10.3781 52.4104L20.6156 66.8708L24.9188 72.9438L33.9469 70.9729L63.8438 64.4417L88.2844 59.1021L118.181 52.5709C122.681 51.5854 125.353 47.8271 124.144 44.1604Z"
                fill="#1D428A"
            />
        </SvgIcon>
    );
};
export default AirTransportIcon;
